import { computed } from 'vue'

export const useClient = () => {
  const isClient = computed(() => typeof window !== 'undefined')

  return {
    isClient,
  }
}
